import triggers from '../store/triggers'
import { isGiftCard, isHotdeal, state } from '../store/state'
import archive from '../store/archive'
import elements from '../store/elements'
import data from '../store/data'

const dqs = (selector) => document.querySelector(selector)
const priceSelector = '#ProductPrice-product-template .money'
const compareSelector = '#ComparePrice-product-template .money'
const discountSelector = '#ProductSaleTag-product-template span'
const options = window.VARIANTS_OPTION_DATA

let mainPrice = dqs(priceSelector)
let comparePrice = dqs(compareSelector)
let discount = dqs(discountSelector)
let firstLoad = true

const updatePrice = (variant) => {
  if (firstLoad) {
    if (isGiftCard) {
      mainPrice = dqs(compareSelector)
      comparePrice = dqs(priceSelector)
    } else {
      mainPrice = dqs(priceSelector)
      comparePrice = dqs(compareSelector)
    }
    discount = dqs(discountSelector)

    firstLoad = false
  }

  if (!variant) return

  const { price: pNew, compare_at_price: pOld } = variant
  // 15% for gift cards
  const priceCompare = (isGiftCard ? pNew * 0.85 : pOld) / 100
  // extra 15% for hot deals
  const price = (isHotdeal ? pNew * 0.85 : pNew) / 100

  if (mainPrice) {
    mainPrice.textContent = '$' + (price).toFixed(2)
  }

  if (comparePrice) {
    comparePrice.textContent = '$' + (priceCompare).toFixed(2)
    comparePrice.hidden = !pOld
  }

  if (discount) {
    discount.textContent = `${Math.round(100 - price / priceCompare * 100)}% OFF`
  }
}

const price = () => {
  updatePrice(state.variant)
  triggers.on('state:variant', updatePrice)
  // Update price for case when layout has been changed and size not selected
  triggers.on('state:layout', (layout) => {
    if (archive.sizes[layout]) return

    const sizes = elements.types.length > 0
      ? options[state.type][layout]
      : options[layout]
    const cOptions = [layout, Object.keys(sizes)[0]]
    const variant = data.variants.find(variant => {
      return cOptions.every(value => variant.options.includes(value))
    })
    updatePrice(variant)
  })
}

export default price
